// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__PVfVt","label":"Section_label__2SdDM","contentWrap":"Section_contentWrap__1FkY2","footer":"Section_footer__2cWH5","footerInner":"Section_footerInner__POo6L"};